import { clearPermissionCache } from "../../auth/PermissionProvider";
import React, { useState } from "react";
import { aplicarTema, temaEscuroAtivo } from "../../utils/tema";
import Dropdown from "../dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { BsArrowBarUp } from "react-icons/bs";
// import { FiSearch } from "react-icons/fi";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import { IoMdNotificationsOutline } from "react-icons/io";
import avatar from "../../assets/img/avatars/simpleAvatar.jpg";

import { toast } from "react-toastify";
import { bare } from "../../services/axios";
import { clearSession, revogarRefresh } from "../../services/session";
import OrganizacaoSelector from "./OrganizacaoSelector";

const Navbar = (props: {
  onOpenSidenav: () => void;
  brandText: string;
  secondary?: boolean | string;
  profileUserName?: string;
}) => {
  const { onOpenSidenav, brandText, profileUserName } = props;
  const [darkmode, setDarkmode] = useState(temaEscuroAtivo);

  const navigate = useNavigate();

  const handleSignOut = () => {
    // Limpa acesso E refresh: sair tem que sair de verdade — deixar o refresh para trás manteria
    // a sessão renovável por 30 dias na máquina de quem acabou de sair.
    // Dispara antes de limpar (o refresh é lido na hora) e não espera: o logout local não depende
    // do servidor.
    void revogarRefresh((body) => bare.post("/Auth/Logout", body));
    clearSession();
    localStorage.removeItem("userName");
    localStorage.removeItem("userEmail");
    clearPermissionCache();
    navigate("/", { replace: true });

    toast.success("👋 You are logout. Bye 👋👋👋👋!!!", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  return (
    <nav className="sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between gap-3 rounded-2xl border border-white/40 bg-white/70 px-4 py-2.5 backdrop-blur-xl dark:border-white/5 dark:bg-[#0b14374d]">
      <div className="ml-1">
        <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-gray-500 dark:text-gray-400">
          NINA
        </p>
        <p className="text-lg font-bold capitalize leading-tight text-navy-700 dark:text-white">
          {brandText}
        </p>
      </div>

      <div className="relative flex items-center gap-1.5 rounded-full bg-white px-2.5 py-2 shadow-[0_8px_30px_rgba(112,144,176,0.12)] dark:!bg-navy-800 dark:shadow-none">
        <button
          type="button"
          aria-label="Abrir menu de navegação"
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-8 w-8" aria-hidden="true" />
        </button>
        <OrganizacaoSelector />
        {/* start Notification */}
        <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdNotificationsOutline className="h-6 w-6 text-gray-600 dark:text-white" />
            </p>
          }
          animation="origin-[65%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
          children={
            <div className="flex w-[360px] flex-  col gap-3 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none sm:w-[460px]">
              <div className="flex items-center justify-between">
                <p className="text-base font-bold text-navy-700 dark:text-white">
                  Notification
                </p>
                <p className="text-sm font-bold text-navy-700 dark:text-white">
                  Mark all read
                </p>
              </div>

              <button className="flex w-full items-center">
                <div className="flex h-full w-[85px] items-center justify-center rounded-xl bg-gradient-to-b from-brandLinear to-brand-500 py-4 text-2xl text-white">
                  <BsArrowBarUp />
                </div>
                <div className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
                  <p className="mb-1 text-left text-base font-bold text-gray-900 dark:text-white">
                    New Update: NINA
                  </p>
                  <p className="font-base text-left text-xs text-gray-900 dark:text-white">
                    A new update for your downloaded item is available!
                  </p>
                </div>
              </button>

              <button className="flex w-full items-center">
                <div className="flex h-full w-[85px] items-center justify-center rounded-xl bg-gradient-to-b from-brandLinear to-brand-500 py-4 text-2xl text-white">
                  <BsArrowBarUp />
                </div>
                <div className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
                  <p className="mb-1 text-left text-base font-bold text-gray-900 dark:text-white">
                    New Update: NINA
                  </p>
                  <p className="font-base text-left text-xs text-gray-900 dark:text-white">
                    A new update for your downloaded item is available!
                  </p>
                </div>
              </button>
            </div>
          }
          classNames={"py-2 top-4 -left-[230px] md:-left-[440px] w-max"}
        />
        <button
          type="button"
          aria-label={darkmode ? "Ativar modo claro" : "Ativar modo escuro"}
          className="cursor-pointer text-gray-600"
          onClick={() => {
            aplicarTema(!darkmode);
            setDarkmode(!darkmode);
          }}
        >
          {darkmode ? (
            <RiSunFill className="h-6 w-6 text-gray-600 dark:text-white" aria-hidden="true" />
          ) : (
            <RiMoonFill className="h-6 w-6 text-gray-600 dark:text-white" aria-hidden="true" />
          )}
        </button>
        {/* Profile & Dropdown */}
        <Dropdown
          button={
            <img
              className="h-10 w-10 rounded-full cursor-pointer"
              src={avatar}
              alt="Simple Avatar"
            />
          }
          children={
            <div className="flex h-48 w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="mt-3 ml-4">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    {`👋 Hello, ` + profileUserName}
                  </p>
                </div>
              </div>
              <div className="mt-3 h-px w-full bg-gray-200 dark:bg-white/20 " />

              <div className="mt-3 ml-4 mr-4 flex flex-col">
                <a
                  href="/admin/profile"
                  className="text-lg text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Profile Settings
                </a>
                <a
                  href="/admin/reset-password"
                  className="text-lg text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Reset Password
                </a>
                <button
                  onClick={handleSignOut}
                  className="active:scale-[.98] linear mt-2 w-full rounded-xl bg-brand-400 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-700 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                >
                  Log Out
                </button>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
